import { render, staticRenderFns } from "./orderable_selector.vue?vue&type=template&id=498f3aed&lang=pug"
import script from "./orderable_selector.vue?vue&type=script&lang=js"
export * from "./orderable_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports